<template>
    <header class="self-header">
        <div class="w-full bg-blue-100">
            <div class="self-gutter">
                <div class="self-content">
                    <div class="flex items-center justify-between">
                        <div class="hidden self-lang-select sm:flex">
                            <a
                                @click.prevent="setLocale('et')"
                                v-if="!$store.getters.isFetchingCustomerInfo"
                                :class="{
                                    'self-lang-select__item--active': $i18n.locale === 'et'
                                }"
                                class="self-lang-select__item cursor-pointer"
                                >ET</a
                            >
                            <a
                                @click.prevent="setLocale('en')"
                                v-if="!$store.getters.isFetchingCustomerInfo"
                                :class="{
                                    'self-lang-select__item--active': $i18n.locale === 'en'
                                }"
                                class="self-lang-select__item cursor-pointer"
                                >EN</a
                            >
                        </div>

                        <div class="flex items-center py-8 sm-down:w-full sm-down:justify-between">
                            <router-link :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/`" class="block sm:hidden">
                                <EstravelSymbolSVG class="block w-28 h-28" alt="Logo" />
                            </router-link>

                            <div class="flex items-center">
                                <div class="relative block mx-6 sm:hidden" ref="dropdownLangSelect">
                                    <button @click="toggleDropdown" class="self-lang-select-sm">
                                        <span
                                            v-if="$i18n.locale === 'et'"
                                            :class="{
                                                'self-lang-select-sm__active': $i18n.locale === 'et'
                                            }"
                                            >ET</span
                                        >
                                        <span
                                            v-else-if="$i18n.locale === 'en'"
                                            :class="{
                                                'self-lang-select-sm__active': $i18n.locale === 'en'
                                            }"
                                            >EN</span
                                        >
                                        <span class="flex-shrink-0 w-12 h-12 text-black transform rotate-90 fill-current">
                                            <IconArrowForwardSVG />
                                        </span>
                                    </button>
                                    <div
                                        v-show="showDropdown"
                                        class="absolute right-0 z-10 p-12 mt-6 text-black bg-white rounded-lg top-full shadow-card"
                                    >
                                        <a
                                            @click.prevent="setLocale('et')"
                                            v-if="!$store.getters.isFetchingCustomerInfo"
                                            :class="{
                                                'self-lang-select__item--active': $i18n.locale === 'et'
                                            }"
                                            class="self-lang-select__item cursor-pointer"
                                            >ET</a
                                        >
                                        <a
                                            @click.prevent="setLocale('en')"
                                            v-if="!$store.getters.isFetchingCustomerInfo"
                                            :class="{
                                                'self-lang-select__item--active': $i18n.locale === 'en'
                                            }"
                                            class="self-lang-select__item cursor-pointer"
                                            >EN</a
                                        >
                                    </div>
                                </div>
                                <a class="flex items-center group" href="https://www.estravel.ee/">
                                    <span
                                        class="flex-shrink-0 hidden w-12 h-12 mr-4 transform rotate-180 fill-current sm:block text-primary"
                                    >
                                        <IconArrowForwardSVG />
                                    </span>
                                    <span
                                        class="leading-tight text-center sm:font-semibold text-3xs sm:text-xs text-primary self-animate-colors group-hover:text-blue-300 max-w-88 sm:max-w-none"
                                        >{{ $t('nav.top.back') }} <span class="font-semibold">estravel.ee</span></span
                                    >
                                </a>
                                <div class="items-center justify-center hidden bg-blue-800 sm:flex rounded-50" style="margin-left: 20px">
                                    <div class="relative flex items-center justify-center w-32 h-32 bg-blue-700 rounded-full">
                                        <div class="flex-shrink-0 w-20 h-20 text-white">
                                            <IconPhoneSVG />
                                        </div>
                                        <span
                                            class="absolute px-3 py-2 font-semibold bg-yellow-400 top-2 -right-8 rounded-11 text-8 text-primary"
                                            >24h</span
                                        >
                                    </div>
                                    <div class="flex flex-col pt-3 pb-2 pl-12 pr-16 text-white">
                                        <span class="block font-semibold leading-normal text-8">(+372)</span>
                                        <span class="block font-semibold leading-none underline text-13">626 6266</span>
                                    </div>
                                </div>
                                <a href="#" class="items-center justify-center hidden ml-12 sm:ml-24">
                                    <span
                                        class="flex items-center justify-center w-32 h-32 bg-yellow-200 rounded-full self-animate-colors hover:bg-yellow-250"
                                    >
                                        <span class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                                            <IconSearchSVG />
                                        </span>
                                    </span>
                                </a>
                                <AccountLogin v-if="isAuthenticated" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- NAVIGATION -->
        <div class="w-full bg-white border-b border-blue-100">
            <div class="self-gutter">
                <div class="self-content">
                    <div class="flex items-center justify-between">
                        <!-- logo start -->
                        <div class="flex-1 hidden pt-10 pb-12 sm:flex">
                            <router-link :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/`" class="flex items-center">
                                <EstravelLogoSVG class="self-logo" alt="Logo" />
                                <span class="hidden ml-10 text-xs font-semibold leading-none text-blue-300 md:block">{{
                                    $t('nav.top.self_service')
                                }}</span>
                            </router-link>
                        </div>
                        <!-- logo end-->
                        <!-- NAV START -->
                        <nav v-if="customerType === 'P'" class="flex items-center flex-1 xs-down:max-w-full xs-down:overflow-auto">
                            <ul v-if="isAuthenticated" class="self-main-nav xs-down:whitespace-nowrap">
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/dashboard`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path === `/${$i18n.locale}/dashboard`
                                        }"
                                    >
                                        {{ $t('nav.top.dashboard') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/info`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path === `/${$i18n.locale}/info`
                                        }"
                                    >
                                        {{ $t('nav.top.my_info') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/reports/invoice-report`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path.startsWith(`/${$i18n.locale}/reports`)
                                        }"
                                    >
                                        {{ $t('nav.top.my_purchases') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/bonuspoints`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path === `/${$i18n.locale}/bonuspoints`
                                        }"
                                    >
                                        {{ $t('dashboard.cards.bonuspoints.title') }}
                                    </router-link>
                                </li>
                            </ul>
                        </nav>
                        <!-- NAV END -->
                        <!-- ÄRIKLIENT               -->
                        <!-- NAV START -->
                        <nav v-else class="flex items-center flex-1 xs-down:max-w-full xs-down:overflow-auto">
                            <ul v-if="isAuthenticated" class="self-main-nav xs-down:whitespace-nowrap">
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/dashboard`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path === `/${$i18n.locale}/dashboard`
                                        }"
                                    >
                                        {{ $t('nav.top.dashboard') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/info`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path === `/${$i18n.locale}/info`
                                        }"
                                    >
                                        {{ $t('nav.top.org_info') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/reports/travels-report`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path === `/${$i18n.locale}/reports/travels-report`
                                        }"
                                    >
                                        {{ $t('nav.top.documents') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/reports/invoice-report`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path.startsWith(`/${$i18n.locale}/reports`)
                                        }"
                                    >
                                        {{ $t('nav.top.reports') }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$store.getters.isFetchingCustomerInfo ? '' : `/${$i18n.locale}/reports/invoice-report`"
                                        class="self-main-nav-item"
                                        :class="{
                                            active: $route.path === `/${$i18n.locale}/reports/invoice-report`
                                        }"
                                    >
                                        {{ $t('nav.top.invoices') }}
                                    </router-link>
                                </li>
                            </ul>
                        </nav>
                        <!-- NAV END -->
                        <div class="flex-1 hidden md:block"></div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script lang="ts">
import store from '@/store';
import { Component, Vue, Watch } from 'vue-property-decorator';
import AccountLogin from '@/components/AccountLogin.vue';
import DocumentSVG from '../assets/static/icons-src/est-document.svg';
import ArrowLeftSVG from '../assets/static/icons-src/est-arrow-left.svg';
import DashboardSVG from '../assets/static/icons-src/est-dashboard.svg';
import FolderSVG from '../assets/static/icons-src/est-folder.svg';
import IconArrowForwardSVG from '../assets/static/icons-src/icon-arrow-forward.svg';
import IconSearchSVG from '../assets/static/icons-src/icon-search.svg';
import EstravelLogoSVG from '../assets/static/icons-src/estravel-logo.svg';
import EstravelSymbolSVG from '../assets/static/icons-src/estravel-symbol.svg';
import IconPhoneSVG from '../assets/static/icons-src/icon-phone.svg';
import { eventBus } from '@/../eventBus';
import router from '@/router';

@Component({
    components: {
        DocumentSVG,
        ArrowLeftSVG,
        DashboardSVG,
        FolderSVG,
        IconArrowForwardSVG,
        IconSearchSVG,
        EstravelLogoSVG,
        EstravelSymbolSVG,
        AccountLogin,
        IconPhoneSVG
    }
})
export default class HeaderTopBarDesktop extends Vue {
    showDropdown = false;

    get isAuthenticated(): boolean {
        return store.getters.isAuthenticated;
    }

    get customerType(): string {
        return store.getters.getCustomerType;
    }

    setLocale(locale) {
        if (this.$i18n.locale !== locale) {
            this.$i18n.locale = locale;
            localStorage.setItem('lang', this.$i18n.locale);
            this.$router.push({
                params: { lang: locale }
            });
        }
        if (this.showDropdown) this.showDropdown = false;
    }

    toggleDropdown(event) {
        this.showDropdown = !this.showDropdown;
        if (this.showDropdown) {
            // Add a click event listener to close the dropdown when clicking outside
            document.addEventListener('click', this.closeDropdownOnClickOutside);
        } else {
            // Remove the event listener when the dropdown is closed
            document.removeEventListener('click', this.closeDropdownOnClickOutside);
        }
    }

    closeDropdownOnClickOutside(event) {
        // Check if the click event target is outside the dropdown container
        if (this.$refs.dropdownLangSelect && !(this.$refs.dropdownLangSelect as Element).contains(event.target)) {
            this.showDropdown = false;
            document.removeEventListener('click', this.closeDropdownOnClickOutside);
        }
    }

    @Watch('$i18n.locale')
    async onLocaleChange() {
        if (store.getters.isAuthenticated) {
            await Promise.all([store.dispatch('getCountry'), store.dispatch('getToplevel'), store.dispatch('getWebContents')]);
            eventBus.$emit('dataFetched');
        } else if (store.getters.getCustomerInfo) {
            await store.dispatch('clear');
            await router.push({ name: 'AccountLogin' });
        }
    }
}
</script>
<style scoped></style>
